import RandingStyle1 from "../../randing/RandingStyle1";
import RandingStyle2 from "../../randing/RandingStyle2";

function Randing019({ urlCode, urlCodeSettingId }) {
  return (
    <RandingStyle1
      urlCode={urlCode}
      urlCodeSettingId={urlCodeSettingId}
      totalStep="2"
      img1Path={`${process.env.REACT_APP_CDN_BASE}/images/004/01_241105_01.gif`}
      // img2Path={`${process.env.REACT_APP_CDN_BASE}/images/004/01_241105_01.gif`}
      // img3Path={`${process.env.REACT_APP_CDN_BASE}/images/002/01_241101_02.gif`} // 스텝 변경되는 이미지
      numberColor="#0854fc"
      qOptionColor="blue"
      keepBTN={`${process.env.REACT_APP_CDN_BASE}/images/004/01_241105_03.png`}
      postBTN={`${process.env.REACT_APP_CDN_BASE}/images/004/01_241105_04.png`}
      companyName="본원"
      // footerPath={`${process.env.REACT_APP_CDN_BASE}/images/footer/ggul.jpg`}
    />
  );
}

export default Randing019;
